// extracted by mini-css-extract-plugin
export default {"list":"FooterNav_list__ky+7C","listItem":"FooterNav_listItem__Jw8pm"};